<template>
  <div class="text-center">
    <span v-if="hasData"
          :title="dataTitle">{{ localizedElapsedTime }}</span>
  </div>
</template>

<script>
  import moment from '../../../common/moment/MomentFactory';
  import LocalizationService from '~/zf/frontend/common/localization/LocalizationService';

  export default {
    name: 'LastDataInput',
    compatConfig: {
      MODE: 3,
    },
    data() {
      return {
        rawValue: null,
        rowData: null,
      };
    },
    computed: {
      hasData() {
        return this.rawValue !== null;
      },
      lastDataInputMoment() {
        return moment(this.rowData.LAST_DATAINPUT_LOCALTIME);
      },
      localizedElapsedTime() {
        const now = moment(this.rowData.LAST_DATAINPUT_LOCALTIME_NOW);
        const elapsedTime = LocalizationService.getDuration(this.lastDataInputMoment, now);
        return LocalizationService.localizeElapsedTime(elapsedTime);
      },
      dataTitle() {
        return `${this.lastDataInputMoment.format('L LT')} (${this.rowData.LOCAL_TIMEZONE_NAME}
                 ${this.rowData.LOCAL_TIMEZONE_OFFSET})`;
      },
    },
    beforeMount() {
      this.rawValue = this.params.value;
      this.rowData = this.params.data;
    },
  };
</script>
